import { spErrorTags } from "@eventr/common";
import { StateCreator } from "zustand";
import { applinksUrl, Utils } from "../../utils";
import { BoundStore } from "../bound.store";
import { useUserPrefsStore } from "../userPrefsState/userPrefs.store";

interface VersionConfigState {
  passwordDefault: boolean;
}
interface VersionConfigActions {
  initVersionConfig: () => void;
  onFirstOpened: () => void;
}
export interface VersionConfigSlice extends VersionConfigState, VersionConfigActions {}

export const createVersionConfigSlice: StateCreator<
  BoundStore,
  [["zustand/devtools", never]],
  [],
  VersionConfigSlice
> = (set) => ({
  passwordDefault: false,
  initVersionConfig: async () => {
    const version = await Utils.getReactVersion();
    const url = applinksUrl(`releases/${version}/config.json`);
    try {
      const response = await fetch(url);
      const data = await response.json();
      console.log(data);
      if (data?.passwordDefault) {
        // Deliberately in-memory only — no `setUserPref` here, so this default does not
        // persist to `localStorage["userPreferences"]`.
        useUserPrefsStore.getState().setLoginMethod("password");
      }
      set({ passwordDefault: data.passwordDefault });
    } catch {
      set({ passwordDefault: false });
    }
  },
  onFirstOpened: async () => {
    if (localStorage.getItem("hasAppOpened") === "true") return;

    localStorage.setItem("hasAppOpened", "true");

    try {
      const retrieved = await fetch("https://g.softpauer.com/retrieve.php");
      const retrievedData = (await retrieved.json())?.token;

      if (retrievedData) {
        // Dynamic import: pendingDeeplink reaches bound.store, which this slice is part of.
        const { navigateToDeeplink } = await import("feat/deeplink/pendingDeeplink");
        navigateToDeeplink(`/guest/resolver/?data=${retrievedData}`);
      }
    } catch (err) {
      spErrorTags(err, ["OnFirstOpened"]);
    }
  },
});
